import React, { createContext, useContext, useState } from 'react';
import { StatefulPopover, PLACEMENT, TRIGGER_TYPE } from 'baseui/popover';
import { Avatar } from 'baseui/avatar';
import { ChevronDown, ChevronUp } from 'baseui/icon';
import './NavUserMenu.css';

export const NavBarUserMenuContext = createContext(null);

export function NavBarUserMenuProvider({ value, children }) {
  return (
    <NavBarUserMenuContext.Provider value={value}>
      {children}
    </NavBarUserMenuContext.Provider>
  );
}

export default function NavUserMenu() {
  const ctx = useContext(NavBarUserMenuContext);
  const [open, setOpen] = useState(false);

  if (!ctx?.userItems?.length) return null;

  const {
    userItems,
    userProfile,
    userImgUrl,
    onUserItemSelect,
    renderItem,
  } = ctx;

  const name = userProfile?.fullName || 'User';

  return (
    <StatefulPopover
      placement={PLACEMENT.bottomRight}
      triggerType={TRIGGER_TYPE.click}
      dismissOnClickOutside
      dismissOnEsc
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      popoverMargin={6}
      overrides={{
        Body: {
          style: {
            zIndex: 1100,
          },
        },
        Inner: {
          style: {
            padding: 0,
            borderRadius: '8px',
            overflow: 'hidden',
          },
        },
      }}
      content={({ close }) => (
        <div className="nav-user-dropdown" role="menu">
          {userItems.map((item, index) => {
            if (item.sectionHeader) {
              return (
                <div
                  key={`section-${item.label}-${index}`}
                  className="nav-user-dropdown-section"
                  role="presentation"
                >
                  {item.label}
                </div>
              );
            }

            const handleActivate = () => {
              if (item.path) {
                onUserItemSelect?.(item);
                close();
              }
            };

            if (React.isValidElement(item.label)) {
              return (
                <div
                  key={`action-${index}`}
                  className="nav-user-dropdown-item nav-user-dropdown-item--muted"
                  role="menuitem"
                >
                  {item.label}
                </div>
              );
            }

            return (
              <button
                key={item.path || index}
                type="button"
                className="nav-user-dropdown-item"
                role="menuitem"
                onClick={handleActivate}
              >
                {renderItem ? renderItem(item) : item.label}
              </button>
            );
          })}
        </div>
      )}
    >
      <button
        type="button"
        className="app-nav-user-menu-btn nav-user-menu-trigger"
        aria-expanded={open}
        aria-haspopup="menu"
        aria-label={`Account menu, ${name}`}
      >
        <Avatar name={name} src={userImgUrl} size="32px" />
        {open ? <ChevronUp size={22} overrides={{ Svg: { style: { marginLeft: '2px' } } }} /> : (
          <ChevronDown size={22} overrides={{ Svg: { style: { marginLeft: '2px' } } }} />
        )}
      </button>
    </StatefulPopover>
  );
}
